import React, { useState, useEffect, useLayoutEffect } from 'react';
import './FlashingTitles.css';

const FlashingTitles = ({ titles, interval}) => {
  // Ensure first title renders immediately for LCP
  const [currentIndex, setCurrentIndex] = useState(0);
  const [show, setShow] = useState(true);
  const [isInitialRender, setIsInitialRender] = useState(true);

  // Use useLayoutEffect to ensure DOM updates happen synchronously before paint
  useLayoutEffect(() => {
    // Mark initial render as complete after first paint
    setIsInitialRender(false);
  }, []);

  useEffect(() => {
    // Don't start animation until after initial render to improve LCP
    if (isInitialRender) return;

    const intervalId = setInterval(() => {
      setShow(false); // Start fade-out
      setTimeout(() => {
        setCurrentIndex((prevIndex) => (prevIndex + 1) % titles.length);
        setShow(true); // Start fade-in
      }, 300); // Match CSS transition duration
    }, interval);

    return () => clearInterval(intervalId);
  }, [titles.length, interval, isInitialRender]);

  // Render first title immediately without any delay
  // Use data-initial to prevent transition on first render
  return (
    <div 
      className={`flashing-title ${show ? 'show' : ''}`}
      data-initial={isInitialRender}
    >
      {titles[currentIndex]}
    </div>
  );
};

export default FlashingTitles;
